import { render } from "./ArticleForm.vue?vue&type=template&id=ecd36d3a"
import script from "./ArticleForm.vue?vue&type=script&lang=js"
export * from "./ArticleForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__